var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visibleCode,"width":"340px","title":_vm.title,"top":"25vh"},on:{"update:visible":function($event){_vm.visibleCode=$event}}},[_c('img',{staticClass:"dialogCode",attrs:{"src":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }